var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wraper"},[_c('navbar'),_c('sidebar'),_c('app-main'),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }